<template>
  <span class="vsh-help-wrap">
    <b-button
      size="sm"
      variant="outline-secondary"
      title="How to use Vehicle Status History"
      aria-label="Help"
      @click="show_help = true"
    >
      <i class="fa fa-info-circle"></i>
    </b-button>

    <b-modal
      v-model="show_help"
      title="Using Vehicle Status History"
      size="lg"
      ok-only
      scrollable
    >
      <div class="vsh-help-body">
        <h4>What this page is</h4>
        <p>
          One row for every saved change to a vehicle's status record: when it changed, who
          changed it, and what the record held afterwards. The <b>VSM board</b> shows where
          each vehicle stands right now — this is how it got there.
        </p>
        <p>
          <b>Updated By</b> names the person who made the change, or <b>SYSTEM</b> when a
          sync or a scheduled job made it. To see which sync, and what it changed in the
          other system, use <b>Vehicle Sync History</b>.
        </p>

        <hr/>

        <h4>The chips</h4>
        <ul>
          <li>
            <b>Status</b> is the wash and availability state — Ready, Dirty, Clean, Washed,
            Out. <b>Maint</b> is the maintenance state — Ready, Pending and Unsafe DVIR (or
            a single DVIR chip if your account combines them), PM, OOS. The Maint group is
            hidden for accounts that don't track one.
          </li>
          <li>
            Each count is for the whole date range, not the filtered list, so picking one
            chip never changes another chip's number. Clicking a selected chip clears it.
          </li>
          <li>
            The chip on the left is the total: how many rows you're looking at out of the
            range. <b>Clear</b> drops every filter at once.
          </li>
          <li>A Status chip and a Maint chip narrow together.</li>
        </ul>

        <hr/>

        <h4>Choosing what loads</h4>
        <ul>
          <li>
            <b>Range</b> picks a window ending today. <b>From</b> and <b>To</b> set any
            window; the arrows either side nudge it a day at a time.
          </li>
          <li>
            The <b>vehicle</b> and <b>tag</b> selects are either/or — choosing one clears
            the other. <b>Search</b> narrows the loaded rows by vehicle, who updated it,
            status, or notes.
          </li>
          <li>
            Changing the range or the vehicle reloads from the server. The chips and the
            keyword box filter what's already loaded, so they're immediate.
          </li>
        </ul>

        <hr/>

        <h4>Columns and download</h4>
        <p>
          Which columns appear is a per-account setting (Setup → Vehicle Status Management →
          history columns), so two accounts won't show the same set. The
          <i class="fa fa-download"></i> icon in the header downloads a CSV of the current
          range with the filters you have applied.
        </p>
      </div>
    </b-modal>
  </span>
</template>

<script>
// how-to modal for VSM History, following the erm_*_help / actuals_*_help house pattern
// (info-icon button + ok-only scrollable modal).
export default {
  name: 'vsm_history_help',
  data() {
    return { show_help: false }
  },
}
</script>

<style scoped>
.vsh-help-body h4 { font-size: 1.05rem; margin-top: 4px; }
.vsh-help-body p, .vsh-help-body li { font-size: 0.95rem; }
.vsh-help-body li { margin-bottom: 6px; }
</style>
